<template>


  <div v-bind:class="[{'bordered': isBordered, 'fullWidth': isFullWidth, 'isPrintVersion': isPrintVersion }, 'couponWrapper']">

        <div class="logo">

        </div>

        <div class="couponBadge">

            <div class="couponBadgeExpirationDate">
              <template v-if="isMedicinalProduct && expirationDate != null">Preis</template><template v-else>Rabatt</template> gültig bis {{ expirationDate }}
            </div>

            <div class="couponBadgeDiscount">

                <template v-if="isMedicinalProduct">
                  {{ endprice }} <sup>*</sup> €
                </template>

                <template v-else>
                  <template v-if="variant.voucher.discount">
                    -{{ discount }} <sup>*</sup> €
                  </template>
                </template>

            </div>

              <!--
              <template v-if="!isMedicinalProduct">
                  statt <span>€ {{ price }}</span>* um € {{ endprice }}
              </template>
            -->


        </div>


        <div class="couponProductImage">

           <img :src="backgroundImage" />

           <template v-if="voucherName == null">
               <div class="couponProductTitle" v-html="product.displayName"></div>
           </template>

           <template v-else>
               <div class="couponProductTitle" v-html="voucherName"></div>
           </template>

           <template v-if="voucherSubtitle != null">
               <div class="couponProductVariant" v-html="voucherSubtitle"></div>
           </template>
           <template v-else>
               <div class="couponProductVariant" v-html="variant.name"></div>
           </template>

         </div>


        <div class="couponNotice">

          <!--
          <template v-if="variant.extRef">PZN {{ variant.extRef }}<br></template>
          <template v-else-if="variant.voucher.productVoucherProductVariants.length">
            PZN<template v-if="variant.voucher.productVoucherProductVariants.length > 1">s</template> {{ variant.voucher.productVoucherProductVariants.map((v) => v.extRef).join(',') }}<br>
          </template>
          -->

          <template v-if="!isMedicinalProduct">
            Unverbindlich empfohlener Verkaufspreis.
            <br>*Preisreduktion vom Apothekenverkaufspreis.
          </template>

          <template v-else>
            *Unverbindlich empfohlener Verkaufspreis.
          </template>

          <!-- {{ variant.extRef }} -->

        </div>

    </div>



</template>



<script>
export default {

    props: {
        productVariant: {
            type: Object,
            default: function() { return { variant: { discount: 0 } } }
        },
        product: {
            type: Object,
            default: function() { return {} }
        },
        voucherName: {
            type: String,
            default: null
        },
        voucherSubtitle: {
            type: String,
            default: null
        },
        voucherPrice: {
            type: Number,
            default: null
        },
        isBordered: {
            type: Boolean,
            default: false
        },
        isFullWidth: {
            type: Boolean,
            default: false
        },
        productVoucherProductVariants: {
            type: Array,
            default: function() { return [] }
        },
        isPrintVersion: {
          type: Boolean,
          default: false
        }

    },

	  data() {
		return {
        variant: null
      }
    },

    created() {

        // console.log("variant: ", this.productVoucherProductVariants);
        this.variant = this.productVariant;
        // console.log("variant: ", this.variant);
        if(this.variant.discount == "") {
            this.variant.discount = 0;
        }

    },

    mounted() {


    },

    computed: {

        isMedicinalProduct() {

            if(this.product.type == this.productTypes.MEDICINAL_PRODUCT.id || this.product.type == this.productTypes.HOMEOPATHIC_MEDICINAL_PRODUCT.id || this.product.type == this.productTypes.TRADITIONAL_HERBAL_MEDICINAL_PRODUCT.id) {
                return true;
            }

            return false;

        },

        productTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_TYPES');
        },

        productAssetTypes() {
    			return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
    		},

        backgroundImage() {

            var foundCoupons = [];
            var foundDefaults = [];

            if(this.product.productAssets.length > 0) {

                // Bei der Coupon-Darstellung bitte das Bild vom Typ „Coupon“ verwenden, oder wenn nicht vorhanden das Bild mit Typ „Default“;
                for(var i = 0; i < this.product.productAssets.length; i++) {

                    if(this.product.productAssets[i].type == this.productAssetTypes.COUPON.id) {
                        foundCoupons.push(i);
                    }
                    else if(this.product.productAssets[i].type == this.productAssetTypes.DEFAULT.id) {
                        foundDefaults.push(i);
                    }
                }

            }

            if(foundCoupons.length > 0) {
                return this.$config.assets + this.product.productAssets[foundCoupons[0]].asset.path + "/" + this.product.productAssets[foundCoupons[0]].asset.filename;
            }
            if(foundDefaults.length > 0) {
                return this.$config.assets + this.product.productAssets[foundDefaults[0]].asset.path + "/" + this.product.productAssets[foundDefaults[0]].asset.filename;
            }

            return '';

        },

        discount() {

            var discount =  this.variant.voucher.discount;

            if(discount == "" || discount == null) {
                return 0;
            }

            if(discount == parseInt(discount)) {
                return parseInt(this.variant.voucher.discount);
            }

            if (discount.indexOf('.') > -1) {
                return discount.toString().replace(".", ",");
            }

            return discount;

        },

        price() {

            if(this.voucherPrice != undefined && this.voucherPrice != "" && this.voucherPrice != null) {
                return this.voucherPrice.toString().replace('.', ',');
            }

            else if(this.variant.price) {
                return this.variant.price.toString().replace('.', ',');
            }

        },

        endprice() {

            if(this.voucherPrice != undefined && this.voucherPrice != null && this.voucherPrice != "") {

                if(this.variant.voucher.discount != null && this.variant.voucher.discount != '') {

                    // var endprice = ( parseFloat((this.voucherPrice).replace(",", ".")) - parseFloat((this.variant.voucher.discount).replace(",", ".")) ).toFixed(2).toString();
                    var endprice = ( parseFloat(this.voucherPrice) - parseFloat((this.variant.voucher.discount).replace(",", ".")) ).toFixed(2).toString();

                    if (endprice.indexOf('.') > -1) {
                        endprice = endprice.toString().replace(".", ",");
                    }

                    return endprice;

                } else {

                    return '';

                }

            } else {

                if(this.variant.voucher.discount != null && this.variant.voucher.discount != '' && this.variant.price != "" && typeof this.variant.price != 'undefined') {

                    var endprice = ( parseFloat((this.variant.price).replace(",", ".")) - parseFloat((this.variant.voucher.discount).replace(",", ".")) ).toFixed(2).toString();

                    if (endprice.indexOf('.') > -1) {
                        return endprice.toString().replace(".", ",");
                    }

                    return endprice;

                } else {

                    return '';

                }

            }
        },

        expirationDate() {

            if(this.variant.voucher.catalogProductVoucherExpirationDate != null && typeof this.variant.voucher.catalogProductVoucherExpirationDate != "undefined") {
                var date = this.variant.voucher.catalogProductVoucherExpirationDate.expirationDate.substring(0, 10);
                // return date.substring(8,10) + '.' + date.substring(5,7) + '.' + date.substring(0,4)+'.';
                return date.substring(8,10) + '.' + date.substring(5,7) + '.' + date.substring(0,4);
            } else {
                return ''
            }

        }

    },

}

</script>


<style lang="scss">

.couponWrapper {
    position: relative;
    width: 500px;
    height: 320px;
    background: #fff;

    &.isPrintVersion {
      width: 300px;
      height: 192px;
      margin: 0 0 15px 0;

      .couponBadgeExpirationDate {
        font-size: .5rem !important;
        padding: 2px 0 0 6px;
      }
      .couponBadgeDiscount {
        font-size: 150% !important;
      }
      .couponNotice {
          font-size: 42%;
      }

      .couponProductTitle {
        font-size: 110% !important;
      }
      .couponProductVariant {
        font-size: 80% !important;
      }

    }


    &.bordered {
      border: 1px solid #ddd !important;
    }

    &.fullWidth {
      width: 100% !important;
    }

    .logo {
        position: absolute;
        z-index: 99;
        width: 20%;
        height: 20%;
        right: 4%;
        top: 6%;
        background: transparent url(../../assets/img/voucher-apokat_logo.png) top right no-repeat;
        background-size: contain;
    }

    .couponBadge {
      position: absolute;
      z-index: 99;
      left: 0;
      top: 0;
      width: 42%;
      height: 50%;
      background: transparent url(../../assets/img/voucher-badge.png) top left no-repeat;
      background-size: contain;
      color: #FFF;

      .couponBadgeExpirationDate {
        font-size: 12px;
        padding: 2px 0 0 6px;
      }

      .couponBadgeDiscount {
        position: absolute;
        z-index: 2;
        width: 80%;
        height: 28% !important;
        left: 0;
        top: 20%;
        font-size: 200%;
        font-weight: 500;
        text-align: center;
        transform: rotate(-10deg);
        display: flex;
        align-items: center;
        justify-content: center;
      }

    }

    .couponProductImage {
      position: absolute;
      z-index: 0;
      left: 0;
      right:0;
      bottom: 4%;
      top: 0;
      width: 90%;
      height: auto;
      margin: 0 auto;

      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;

      img {
        object-fit: contain;
        width: 70%;
        height: auto;
        max-height: 70%;
      }

      .couponProductTitle {
        font-size: 150%;
        line-height: 110%;
        font-weight: 300;
        width: 100%;
        white-space: normal;
        text-align: center;
        p {
          margin: 0 !important;
        }
      }

      .couponProductVariant {
        margin-top: 2px;
        p {
          margin: 0 !important;
        }
      }
    }

    .couponNotice {
        font-size: 70%;
        font-style: italic;
        line-height: 1;
        left: 0;
        bottom: 0;
        position: absolute;
        writing-mode: vertical-lr;
        transform: scale(-1);
        padding: 8px 6px;
    }
}

</style>
